import React, { useState, useEffect, useContext } from "react";
import {
  getResDataFirebase,
  getResearchFirebase,
} from "../Utils/firebaseResearch";

import { UserContext } from "./UserContext";

export const ResearchContext = React.createContext();

export const ResearchStorage = ({ children }) => {
  const { user } = useContext(UserContext);
  const [participants, setParticipants] = useState(null);
  const [sessionTime, setSessionTime] = useState(0);
  const [startSessionTime, setStartSessionTime] = useState(false);
  const [resUser, setResUser] = useState({});

  useEffect(() => {
    getResDataFirebase().then(function (result) {
      setParticipants(result);
    });
  }, []);

  useEffect(() => {
    if (startSessionTime) {
      const timer = setInterval(() => {
        setSessionTime((prevTime) => prevTime + 1);
      }, 1000);

      return () => clearInterval(timer);
    }
  }, []);

  return (
    <ResearchContext.Provider
      value={{
        startSessionTime,
        setStartSessionTime,
        participants,
        setParticipants,
        resUser,
        setResUser,
        sessionTime,
        setSessionTime,
      }}
    >
      {children}
    </ResearchContext.Provider>
  );
};
